import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoArticleStockOverview} from "./models/DtoArticleStockOverview";
import {DtoCurrentStockBaseItems} from "./models/DtoCurrentStockBaseItems";
import {DtoCurrentStockFilter} from "./models/DtoCurrentStockFilter";

@Injectable()
export class StockOverviewService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'stock'
    }

    public getCurrentStockBaseItems = (): Observable<DtoCurrentStockBaseItems> => {
        return this.http.get<DtoCurrentStockBaseItems>(`${this.apiUrl}/currentstock/baseitems`);
    };

    public getCurrentStock = (filter: DtoCurrentStockFilter): Observable<DtoArticleStockOverview[]> => {
        return this.http.post<DtoArticleStockOverview[]>(`${this.apiUrl}/currentstock`, filter);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/stock/stock-overview/stock-overview.service.ts